import { prop } from 'ramda'

export const CurrencyRateSerializer = formValues => {
  const currency = prop('currency', formValues)
  const rate = prop('rate', formValues)

  return { currency, rate }
}
